import { render, staticRenderFns } from "./colxx.vue?vue&type=template&id=7444576c&"
import script from "./colxx.vue?vue&type=script&lang=js&"
export * from "./colxx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "colxx.vue"
export default component.exports